import { AllianceOverview, AllianceStatus } from './alliance';
import type { Role } from './auth';
import { ServiceCategory } from './service';
export const COMPANY_TYPES = {
  INDIVIDUAL: 'individual',
  COMPANY: 'company',
  ORGANIZATION: 'organization',
} as const;

export type ProfileType = Extract<Role, 'freelancer' | 'recruiter'>;
export type CompanyType = (typeof COMPANY_TYPES)[keyof typeof COMPANY_TYPES];
export type UserStatus = 'active' | 'inactive' | 'suspended' | 'banned';
export type ObnlReviewStatus = 'not_applicable' | 'pending' | 'approved' | 'rejected';

export interface ProfileAchievement {
  id: string;
  profile_id: string;
  client_name: string;
  project_name: string;
  project_description: string;
  project_image_url: string;
  services: ServiceCategory[];
}

export interface FreelancerStats {
  overall_rating: number;
  reviews_count: number;
  projects_count: number;
}

export interface City {
  id: number;
  name: string;
  latitude?: number;
  longitude?: number;
}

export interface Profile {
  id: string;
  first_name: string;
  last_name?: string;
  languages?: string[];
  is_remote: boolean;
  city_id?: number;
  city?: City;
  postal_code?: string;
  role: Role;
  avatar_url?: string;
  bio?: string;
  created_at?: string;
  updated_at?: string;
  email?: string; // for convenience, if joined with auth.users
  phone?: string; // if you store phone elsewhere or join
  company_type?: CompanyType;
  company_name?: string;
  job_title?: string;
  organization_website?: string;
  organization_number?: string;
  obnl_review_status?: ObnlReviewStatus;
  obnl_reviewed_at?: string;
  obnl_reviewed_by?: string;
  services?: ServiceCategory[];
  status: UserStatus;
  industries?: Array<{
    id: number;
    slug: string;
    label: string;
  }>;
  achievements?: ProfileAchievement[];
  notification_accepted?: boolean;
  newsletter_accepted?: boolean;
}

export type FreelancerProfile = Omit<Profile, 'industries' | 'city'> & {
  city?: { name: string };
  achievements?: ProfileAchievement[];
  stats: {
    overall_rating: number;
    reviews_count: number;
    projects_count: number;
    alliance_count: number;
  };
  recent_alliances?: Array<AllianceOverview>;
  full_access: boolean;
  alliance_status: AllianceStatus;
};

export type ProfileProject = {
  id: string;
  job_title: string;
  job_completed_at: string;
  client_first_name: string;
  client_last_name: string | null;
  client_company_name: string | null;
  client_avatar_url: string | null;
};
